import React from "react";
import styled from "styled-components";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Wave = () => {
  const controls = useAnimation();
  const [element, view] = useInView({ treshold: 0.75 });
  const svgAnim = {
    show: { pathLength: 0, pathOffset: 1 },
    hidden: { pathLength: 1, pathOffset: 0 },
  };
  if (view) {
    controls.start("show");
  } else {
    controls.start("hidden");
  }
  return (
    <WaveSvg
      id="visual"
      viewBox="0 0 900 600"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <rect x="0" y="0" width="900" height="600" fill="#ffffff"></rect>
      <motion.path
        variants={svgAnim}
        initial="show"
        animate={controls}
        transition={{ duration: 1 }}
        ref={element}
        d="M0 138L16.7 122.8C33.3 107.7 66.7 77.3 100 89.7C133.3 102 166.7 157 200 185.8C233.3 214.7 266.7 217.3 300 230.7C333.3 244 366.7 268 400 256C433.3 244 466.7 196 500 169.3C533.3 142.7 566.7 137.3 600 123.2C633.3 109 666.7 86 700 108.5C733.3 131 766.7 199 800 221.2C833.3 243.3 866.7 219.7 883.3 207.8L900 196"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        stroke="#83b3fc"
        strokeWidth="2"
      ></motion.path>
    </WaveSvg>
  );
};

const WaveSvg = styled.svg`
  position: absolute;
  left: 0;
  z-index: -1;
`;

export default Wave;
